import Actions, { getUserInfo } from '@/apis/team';
import menuConfig, { noTeam } from '@/pages/team/menuConfig'

const MENU_LIST = 'MENU_LIST'
const MENU_KEY = 'MENU_KEY'
const USER_INFO = 'USER_INFO'
const GAME_ID = 'GAME_ID'
const GAME_LIST = 'GAME_LIST'
const TEAM_LIST = 'TEAM_LIST'
const ROLE = 'ROLE'
const TEAM_BASE_INFO = 'TEAM_BASE_INFO'
const TEAM_INFO = 'TEAM_INFO'
const LEADERBOARD_BUILD = 'LEADERBOARD_BUILD'
const LEADERBOARD_PRESTIGE = 'LEADERBOARD_PRESTIGE'

const initState = {
  menuList: null,
  userInfo: {},
  game: null,
  gameList: [],
  role: null,
  teamList: null,
  teamBaseInfo: null,
  teamInfo: {},
  leaderboardPrestige: null,
  leaderboardBuild: null,
  menuKey: 1
}

// reducer
export function teamReducer(state = initState, action) {
  switch (action.type) {
    case MENU_LIST:
      return { ...state, menuList: action.payload }
    case MENU_KEY:
      return { ...state, menuKey: action.payload }
    case USER_INFO:
      return { ...state, userInfo: action.payload }
    case GAME_ID:
      return { ...state, game: action.payload }
    case GAME_LIST:
      return { ...state, gameList: action.payload }
    case TEAM_LIST:
      return { ...state, teamList: action.payload }
    case ROLE:
      return { ...state, role: action.payload }
    case TEAM_INFO:
      return { ...state, teamInfo: action.payload }
    case TEAM_BASE_INFO:
      return { ...state, teamBaseInfo: action.payload }
    case LEADERBOARD_PRESTIGE:
      return { ...state, leaderboardPrestige: action.payload }
    case LEADERBOARD_BUILD:
      return { ...state, leaderboardBuild: action.payload }
    default:
      return state
  }
}

// actions creater
function setMenu(data) {
  return { type: MENU_LIST, payload: data }
}

function setUserInfo(data) {
  return { type: USER_INFO, payload: data }
}
function setRole(data) {
  return { type: ROLE, payload: data }
}

function setGameId(data) {
  return { type: GAME_ID, payload: data }
}

function setGameList(data) {
  return { type: GAME_LIST, payload: data }
}
function setTeamList(data) {
  return { type: TEAM_LIST, payload: data }
}
function setTeamBaseInfo(data) {
  return { type: TEAM_BASE_INFO, payload: data }
}
function setTeamInfo(data) {
  return { type: TEAM_INFO, payload: data }
}
function setMenuKey(data) {
  return { type: MENU_KEY, payload: data }
}
function setLeaderboardBuild(data) {
  return { type: LEADERBOARD_BUILD, payload: data }
}
function setLeaderboardPrestige(data) {
  return { type: LEADERBOARD_PRESTIGE, payload: data }
}

export function dispatchSetTeamInfo(parmas) {
  return dispatch => {
    dispatch(setTeamInfo(parmas))
  }
}

export function dispatchSetUserInfo(parmas) {
  return dispatch => {
    dispatch(setUserInfo(parmas))
  }
}

export function getGameList(gameList) {
  return async dispatch => {
    const res = await Actions.getGame()
    if (res.code === 200) {
      dispatch(setGameList(res.data))
    }
  }
}

export function checkGame(gameId) {
  return async dispatch => {
    dispatch(setGameId(gameId))
    const res = await Actions.userInfo({ game_id: gameId })
    if (res.code == 200) {
      const role = res.data.team_job
      dispatch(setUserInfo(res.data))
      dispatch(setRole(role))
      let menuList = menuConfig.filter(v => {
        if (!v.roles || v.roles.indexOf(role) >= 0) {
          return true
        } else {
          return false
        }
      })
      dispatch(setMenu(menuList))
    }
    const params = {
      game_id: gameId,
      sort: 1,
      page_size: 10
    }
    const teamListRes = await Actions.teams(params)
    if (teamListRes.code == 200) {
      dispatch(setTeamList(teamListRes.data))
    }
  }
}

export function getTeamList(params) {
  return async dispatch => {
    const res = await Actions.teams(params)
    if (res.code == 200) {
      dispatch(setTeamList(res.data))
    }
  }
}
export  function  getTeamBaseInfo(param) {
  return async dispatch => {
    const res = await Actions.getTeamBaseInfo(param)
    if (res.code == 200) {
      dispatch(setTeamBaseInfo(res.data))
    }
  }
}

export function getMenu(param) {
  return dispatch => {
  }
}
